import {
  brandCaptionLowerThird,
  BrandCaptionLowerThird,
  brandCaptionLowerThirdEntityId,
  BrandCaptionLowerThirdEntityId,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUpdateVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUpdateVO.validationSchema()
  );

  constructor(readonly value: RoomBrandCaptionLowerThirdUpdate) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdUpdateVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "captionId", "update"],
      properties: {
        roomId,
        brandId: brandEntityId,
        captionId: brandCaptionLowerThirdEntityId,
        update: brandCaptionLowerThird
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdUpdate {
  roomId: RoomId;
  brandId: BrandEntityId;
  captionId: BrandCaptionLowerThirdEntityId;
  update: BrandCaptionLowerThird;
}
